<dialog-draggable-header>Multi-Row Update</dialog-draggable-header>

<gm-loading-spinner *ngIf="loading"></gm-loading-spinner>

<div mat-dialog-content>
   <form class="flex-dialog-container" [formGroup]="multiRowUpdateForm">
      <div class="space-between-items">
         <div></div>
         <div>
            <h1 mat-dialog-title>Enable</h1>
         </div>
      </div>
      <div class="space-between-items mb-2">
         <mat-form-field>
            <mat-label>NEC LEC</mat-label>
            <input #neclec matInput formControlName="necLec" autocomplete="off" [minLength]="NEC_LEC_MIN_LENGTH"
               (input)="neclec.value = $event.target.value.toUpperCase()" [maxLength]="NEC_LEC_MAX_LENGTH"
               [value]="neclec.value" (keyup.enter)="enableDisableShippedtoDateBank($event)" (blur)="enableDisableShippedtoDateBank($event)"/>
            <mat-error *ngIf="this.multiRowUpdateForm.get('necLec').hasError('pattern')">
               The only valid entries for the NEC LEC are REL, (REL) or 2 letters (i.e. A, AA, B, BA, etc...)
            </mat-error>
         </mat-form-field>
         <mat-checkbox #necLecCheck color="primary" formControlName="chkNecLec" (change)="enableDisableNeclecTlAfctCertDataTlLead($event)"></mat-checkbox>
      </div>

      <div class="space-between-items">
         <mat-checkbox color="primary" formControlName="toolAffected">Is Tool Affected?</mat-checkbox>
         <mat-checkbox #toolAffectedCheck color="primary" formControlName="chkToolAffected" (change)="enableDisableNeclecTlAfctCertDataTlLead($event)"></mat-checkbox>
      </div>

      <div class="space-between-items">
         <mat-checkbox color="primary" formControlName="certDataAffected">Is Certification Data Affected?</mat-checkbox>
         <mat-checkbox #certDataAffectedCheck color="primary" formControlName="chkCertDataAffected" (change)="enableDisableNeclecTlAfctCertDataTlLead($event)"></mat-checkbox>
      </div>

      <div class="space-between-items">
         <mat-form-field>
            <mat-label>Tool Lead Release Level</mat-label>
            <input #tlr matInput formControlName="tlLeadRelLvl" autocomplete="off" (keyup.enter)="enableDisableShippedtoDateBank($event)" (blur)="enableDisableShippedtoDateBank($event)"
               [value]="tlr.value.toString().toUpperCase()" />
         </mat-form-field>
         <mat-checkbox #tlLeadRelLvlCheck color="primary" formControlName="chkTlLeadRelLvl" (change)="enableDisableNeclecTlAfctCertDataTlLead($event)"></mat-checkbox>
      </div>

      <div class="space-between-items">
         <mat-form-field>
            <mat-label>Shipped to Databank Date</mat-label>
            <input #dtShippedToDatabank matInput [matDatepicker]="picker" formControlName="dtShippedToDatabank"
            (dateInput)="disableEnableFormField(necComplDate, $event)" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
         </mat-form-field>
         <mat-checkbox #dtShippedToDatabankCheck color="primary" formControlName="chkDtShippedToDataBank" (change)="enableDisableNecCompletionDate($event)" 
      
         ></mat-checkbox>
      </div>

      <div class="space-between-items">
         <mat-form-field>
            <mat-label>NEC Completion Date</mat-label>
            <div
               matTooltip='Notification Engineer Change Complete Date - Can be entered after entering the Shipped to Databank Date'>
               <input #necComplDate matInput [matDatepicker]="pickerNec" formControlName="necCompleteDate" />
            </div>
            <mat-datepicker-toggle matSuffix [for]="pickerNec"></mat-datepicker-toggle>
            <mat-datepicker #pickerNec></mat-datepicker>
         </mat-form-field>
         <mat-checkbox #necCompleteDateCheck color="primary" formControlName="chkNecCompleteDate" (change)="enableDisableNecCompletionDateCheck($event)" ></mat-checkbox>
      </div>

      <div class="space-between-items">
         <mat-form-field>
            <mat-label>Design Source</mat-label>
            <mat-select formControlName="designSourceId" (selectionChange)="enableDisableShippedtoDateBank($event)">
               <mat-option *ngFor="let ds of designSources" [value]="ds.id">
                  {{ds.sourceName}}
               </mat-option>
            </mat-select>
         </mat-form-field>
         <mat-checkbox #designSourceIdCheck color="primary" formControlName="chkDesignSourceId"  (change)="enableDisableNeclecTlAfctCertDataTlLead($event)"></mat-checkbox>
      </div>

   </form>

</div>
<div mat-dialog-actions class="mat-dialog-actions-end no-margin">
   <button mat-raised-button (click)="selectAll()">Check All</button>
   <button mat-raised-button (click)="selectNone()">Check None</button>
   <button mat-raised-button color="primary" (click)="onUpdateClick()" (keypress.enter)="onUpdateClick()"
      [disabled]="!hasEnabledFields || loading || multiRowUpdateForm.invalid">Update</button>
   <button mat-raised-button mat-dialog-close (click)="onCancelClick()" (keypress.enter)="onCancelClick()"
      cdkFocusInitial [disabled]="loading">Cancel</button>
</div>